import React from 'react'
import noop from 'lib/function/noop'
import DropdownBehaviourState, { DROPDOWN_BEHAVIOUR_INITIAL_STATE, DropdownBehaviourDispatchAction } from './DropdownBehaviourState'

export const DropdownBehaviourStateContext = React.createContext<DropdownBehaviourState>(DROPDOWN_BEHAVIOUR_INITIAL_STATE)
export const DropdownBehaviourDispatchContext = React.createContext<React.Dispatch<DropdownBehaviourDispatchAction>>(noop)
